import {Injectable} from '@angular/core';
import io from 'socket.io-client';
import {Subject} from 'rxjs';
import {ConfigService} from './config.service';
import {MessageService} from './message.service';

@Injectable({
    providedIn: 'root'
})
export class SocketService {
    socket: any;
    public commentSubject = new Subject<any>();
    public dashboardSubject = new Subject<any>();
    public attachmentSubject = new Subject<any>();
    public solPrvdSubject = new Subject<any>();

    constructor(private config: ConfigService, private messageService: MessageService) {
        const SOCKET_IP = this.config.SOCKET_IP;
        this.socket = io(SOCKET_IP, {forceNew: true, autoConnect: true});
        this.socket.on('comment', (data) => {
            this.commentSubject.next(data);
        });
        this.socket.on('dashboard', (data) => {
            this.dashboardSubject.next(data);
        });
        this.socket.on('attachment', (data) => {
            this.attachmentSubject.next(data);
        });
        this.socket.on('solProvd', (data) => {
            this.solPrvdSubject.next(data);
        });
        this.socket.on('connect', () => {
            console.log('\n Socket Connected :');
            if (this.messageService.getUserId() !== null) {
                this.socket.emit('userRoomJoin', this.messageService.getUserId());
            }
            const userGroups = this.messageService.groupId;
            if (userGroups !== undefined) {
                for (let i = 0; i < userGroups.length; i++) {
                    this.socket.emit('groupRoomJoin', userGroups[i].groupId);
                }
            }
        });
        this.socket.on('disconnect', (reason) => {
            console.log('\n Socket DisConnected');
            console.log(reason);
        });
    }

    userRoomJoin(id) {
        // console.log('join:' + id);
        this.socket.emit('userRoomJoin', id);
    }

    groupRoomJoin(id) {
        this.socket.emit('groupRoomJoin', id);
    }

    userRoomLeave(id) {
        this.socket.emit('userRoomLeave', id);
    }

    groupRoomLeave(id) {
        this.socket.emit('groupRoomLeave', id);
    }
}
